"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("@emotion/styled"));
const Helper = (0, styled_1.default)('small')({
    display: 'inline-block',
    marginTop: 7
}, ({ theme, variant }) => ({
    fontSize: theme.typography.fontSize.small,
    fontWeight: theme.typography.fontWeightLight,
    color: theme.palette.colors.blackCoral,
    ...(variant === 'success' && {
        color: theme.palette.success
    }),
    ...(variant === 'error' && {
        color: theme.palette.colors.crayola
    })
}));
exports.default = Helper;
//# sourceMappingURL=Helper.js.map